import React from 'react';

import { LinearProgress } from '@mui/material';

import FlightEventReportDataGrid from '../../components/flight-event-report/FlightEventReportDataGrid';
import useGetEventReportsByType from '../../core/api/hooks/event-report/useGetEventReportsByType';
import { EventFormStatus, ReportType } from '../../core/api/clients';

interface IFlightEventSubmissions {
  hours?: number;
  statuses?: EventFormStatus[];
  isOwner?: boolean;
  pageSize?: number;
  readonly?: boolean;
}
function FlightEventList({ hours = 0, statuses = [], isOwner = false, pageSize = 25, readonly = false }: IFlightEventSubmissions): JSX.Element {
  const reports = useGetEventReportsByType({
    reportType: ReportType.FlightEventReport,
    hours,
    statuses,
    isOwner,
  });
  if (reports?.isLoading) {
    return (
      <LinearProgress />
    );
  }

  return (
    <FlightEventReportDataGrid
      data={reports}
      reportType="flight-event"
      areSubmissions
      pageSize={pageSize}
    />
  );
}

export default FlightEventList;
